export default __webpack_public_path__ + "static/media/inputSPIimg.0d96c623.png";